/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LogoutResponse model module.
* @module model/LogoutResponse
* @version 2020-12-7
*/
export default class LogoutResponse {
    /**
    * Constructs a new <code>LogoutResponse</code>.
    * ログアウトレスポンス
    * @alias module:model/LogoutResponse
    * @class
    * @param result {module:model/LogoutResponse.ResultEnum} 
    */

    constructor(result) {
        
        
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>LogoutResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LogoutResponse} obj Optional instance to populate.
    * @return {module:model/LogoutResponse} The populated <code>LogoutResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogoutResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/LogoutResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
